/*
  Add here your own custom javascript codes
*/
// Collapsible collection description
document.addEventListener('DOMContentLoaded', function () {
  const descriptionEls = document.querySelectorAll('.description.rte');

  descriptionEls.forEach(function (el) {
    if (el.scrollHeight <= 90) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('collection-description-collapsible', 'is-collapsed');

    const inner = document.createElement('div');
    inner.classList.add('collection-description-inner');

    el.parentNode.insertBefore(wrapper, el);
    inner.appendChild(el);
    wrapper.appendChild(inner);

  const toggle = document.createElement('button');
toggle.setAttribute('type', 'button');
toggle.classList.add('collection-description-toggle');
toggle.textContent = 'Ver mais';
wrapper.appendChild(toggle);


    toggle.addEventListener('click', function () {
      const collapsed = wrapper.classList.toggle('is-collapsed');
      toggle.textContent = collapsed ? 'Ver mais' : 'Ver menos';
      if (collapsed) {
  const y = wrapper.getBoundingClientRect().top + window.scrollY - 80;
  window.scrollTo({ top: y, behavior: 'smooth' });
}

    });
  });
});

// DIAMORA — Upsell cart buttons
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.diamora-upsell-add');
  if (!btn || btn.getAttribute('data-loading') === 'true') return;
  var variantId = parseInt(btn.getAttribute('data-variant-id'));
  if (!variantId) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  btn.setAttribute('data-loading', 'true');
  btn.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(res) { return res.json(); })
  .then(function() {
    // Busca o HTML atualizado do offcanvas via Sections API
    return fetch('/?sections=offcanvas-cart');
  })
  .then(function(res) { return res.json(); })
  .then(function(sections) {
    var newHtml = sections['offcanvas-cart'];
    if (newHtml) {
      var offcanvas = document.getElementById('offcanvas-cart');
      if (offcanvas) {
        // Substitui o conteúdo mantendo o offcanvas aberto
        var tmp = document.createElement('div');
        tmp.innerHTML = newHtml;
        var newContent = tmp.querySelector('#offcanvas-cart');
        if (newContent) {
          offcanvas.innerHTML = newContent.innerHTML;
        } else {
          offcanvas.innerHTML = newHtml;
        }
      }
    }
  })
  .catch(function() {
    btn.textContent = '+ Adicionar';
    btn.removeAttribute('data-loading');
  });
}, true);





